import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const Messages = ({ allMessages, chatHead }) => {
  const messageRef = useRef(null);
  useEffect(() => {
    messageRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [allMessages]);
  const admin = useSelector((state) => state.adminDetail);
  return (
    <>
      {allMessages.map((messageData, idx) => {
        const { text, sender } = messageData;
        return (
          <div
            className={
              sender === admin.userId
                ? "message_container owner"
                : "message_container"
            }
            ref={messageRef}
            key={idx}
          >
            {sender !== admin.userId &&
              (chatHead?.profile ? (
                <img
                  className="avatar"
                  src={`https://drive.google.com/thumbnail?id=${chatHead.profile}`}
                  alt="profile"
                />
              ) : (
                <span className="avatar">
                  {chatHead?.user ? chatHead.user.substr(0, 1) : "N"}
                </span>
              ))}
            <span
              className={
                // idx >= allMessages.length - 1 &&
                // readStatus &&
                // sender === data.userId
                //   ? "message seenTag"
                "message "
              }
            >
              {text}
            </span>
          </div>
        );
      })}
    </>
  );
};

export default Messages;
